import { formatDateString } from "src/Utils/DateFormatting/DateFormatter";
import { IAuraSoftwareSuiteLicensesInfo} from "src/Utils/Hooks/useGetAdminInfo/useGetAuraSupportInfo";
import tableStyles from 'src/Utils/CssModules/table.module.css';
import { isDateExpired } from "src/Utils/DateExpiry/DateExpiryChecker";
import { getLicenseType } from "src/Utils/Hooks/useGetAdminInfo/LicenseTypeHelper";

export interface IAuraSoftwareSuiteLicensesAssignedInfo{
    auraSoftwareSuiteLicenses: IAuraSoftwareSuiteLicensesInfo
}

const AuraSoftwareSuiteLicensesAssignedInfo: React.FC<IAuraSoftwareSuiteLicensesAssignedInfo> = ({auraSoftwareSuiteLicenses}) => {

    return(
        <>
            {/* <td className={tableStyles.data} style={{ fontWeight: '600' }}>{auraSoftwareSuiteLicenses?.entitlementId}</td> */}
            <td className={tableStyles.data}>{getLicenseType(auraSoftwareSuiteLicenses?.licenseType)}</td>
            <td className={tableStyles.data}>{formatDateString(auraSoftwareSuiteLicenses?.activationDateInAura)}</td>
            <td className={tableStyles.data} style={isDateExpired(auraSoftwareSuiteLicenses?.licenseEndDate) ? {color: 'red'} : {}}>{auraSoftwareSuiteLicenses?.licenseEndDate ? formatDateString(auraSoftwareSuiteLicenses.licenseEndDate) : '-'}</td>
            <td className={tableStyles.data}>{auraSoftwareSuiteLicenses?.distributorName}</td>
            <td className={tableStyles.data}>{auraSoftwareSuiteLicenses?.clinicName ?? '-'}</td>
           
            <td></td>
        </>
    );
}

export default AuraSoftwareSuiteLicensesAssignedInfo;